import { useState } from "react";
import ExplanationModal from "../../Common/ExplanationModal";
import classes from "./EntityScoreButton.module.css";

const EntityScoreButton = ({ entity, isLoading = false }) => {
  const [isExplanationModalOpen, setExplanationModalOpen] = useState(false);

  // Don't render if loading or score is not available
  if (isLoading || typeof entity?._score !== "number") {
    return null;
  }

  const handleScoreClick = (e) => {
    e.stopPropagation();
    if (entity._explanation) {
      setExplanationModalOpen(true);
    }
  };

  return (
    <>
      <div className={classes.scoreContainer}>
        <span className={classes.scoreLabel}>Score:</span>
        <button
          className={classes.scoreButton}
          onClick={handleScoreClick}
          title={entity._explanation ? "Click to see explanation" : "Score"}
        >
          {entity._score.toFixed(3)}
        </button>
      </div>

      <ExplanationModal
        isOpen={isExplanationModalOpen}
        onClose={() => setExplanationModalOpen(false)}
        explanation={entity._explanation}
      />
    </>
  );
};

export default EntityScoreButton;
